"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var Mtcnn_1 = require("./Mtcnn");
tslib_1.__exportStar(require("./Mtcnn"), exports);
tslib_1.__exportStar(require("./MtcnnOptions"), exports);
function createMtcnn(weights) {
    var net = new Mtcnn_1.Mtcnn();
    net.extractWeights(weights);
    return net;
}
exports.createMtcnn = createMtcnn;
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/face-api.js/build/commonjs/mtcnn/index.js
 ** module id = 1485
 ** module chunks = 0
 **/